<div class="flex items-center gap-2" [attr.data-testid]="testId()">
  <p-button
    icon="pi pi-minus"
    styleClass="btn-select-dark tree-control-button"
    [ariaLabel]="'project.steps.criteriaWeightsOverview.zoomOut' | transloco"
    [pTooltip]="'project.steps.criteriaWeightsOverview.zoomOut' | transloco"
    [attr.data-testid]="testId() + '-zoom-out'"
    (onClick)="zoomOut.emit()"
  ></p-button>
  <span class="w-12 text-center text-sm tabular-nums" [attr.data-testid]="testId() + '-zoom-level'">
    {{ zoomLabel() }}
  </span>
  <p-button
    icon="pi pi-plus"
    styleClass="btn-select-dark tree-control-button"
    [ariaLabel]="'project.steps.criteriaWeightsOverview.zoomIn' | transloco"
    [pTooltip]="'project.steps.criteriaWeightsOverview.zoomIn' | transloco"
    [attr.data-testid]="testId() + '-zoom-in'"
    (onClick)="zoomIn.emit()"
  ></p-button>
  <p-button
    icon="pi pi-refresh"
    styleClass="btn-select-dark tree-control-button"
    [ariaLabel]="'project.steps.criteriaWeightsOverview.resetView' | transloco"
    [pTooltip]="'project.steps.criteriaWeightsOverview.resetView' | transloco"
    [attr.data-testid]="testId() + '-reset'"
    (onClick)="resetView.emit()"
  ></p-button>
</div>
